
import React from 'react';
import './MPseriesplaten.css';
import BJMSeries from '../../../imgs/MPseriesplatense.webp'; 

const MPseriesplaten = () => {
  return (
    <div className="MPseriesp-container">
      <img src={BJMSeries} alt="Fitting Corrosion" className="MPseriesp-image" />
    </div>
  );
};

export default MPseriesplaten;
